import React, { forwardRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { GridActionsCellItem } from "@mui/x-data-grid";
import * as Icons from "react-bootstrap-icons";
import Inputer from "Utils/Helpers/Inputer";
import { useSetState } from "Utils/Helpers/Hooks";
import { Grid2 } from "@mui/material";
import MButton from "Utils/Helpers/MButton";
import { put_site_data } from "http/components/SiteData";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setHomeData } from "../../../../../Redux/slices/mngrSlice";
import MInfoShow from "Utils/Helpers/MInfoShow";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditHomeData({ cell, row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selected, setSelected] = useState(null);
  const [controls, setControls] = useSetState({
    title: {
      label: "Title",
      type: "text",
      multiLine: false,
      placeholder: "Enter title",
      value: "",
      validation: false,
    },
    text: {
      label: "Text",
      type: "text",
      multiLine: true,
      placeholder: "Enter text",
      value: "",
      validation: false,
    },
  });

  const onEnter = () => {
    setControls({ text: { value: "", validation: false } });
    setControls({ title: { value: "", validation: false } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleRow = (selected_value) => {
    if (
      !editMode ||
      (editMode && selected.language !== selected_value.language)
    ) {
      setEditMode(true);
      setSelected(selected_value);
      setControls({ text: { value: selected_value.body, validation: true } });
      setControls({ title: { value: selected_value.title, validation: true } });
    } else {
      setEditMode(false);
      setSelected(null);
      setControls({ text: { value: "", validation: false } });
      setControls({ title: { value: "", validation: false } });
    }
  };

  const onSubmit = async () => {
    const { title, text } = controls;
    if (title.validation) {
      dispatch(HandleLoading(true));
      const response = await put_site_data({
        ...selected,
        title: title.value,
        body: text.value,
      });
      if (CheckApiStatus(response)) {
        dispatch(setHomeData(true));
        enqueueSnackbar("Edit Success", { variant: "success" });
      }
      setShow(false);
      setEditMode(false);
      setSelected(null);
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <>
      <GridActionsCellItem
        icon={<Icons.Pencil size={16} />}
        label="Edit"
        onClick={setShowDialog}
        className="btn-manager btn-edit"
      />
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"md"}
          onClose={handleClose}
          TransitionProps={{ onEnter: onEnter }}
          aria-describedby="alert-dialog-edit"
        >
          <DialogTitle>{`Edit (${row.title})`}</DialogTitle>
          <DialogContent>
            {show && (
              <Grid2 container spacing={2} className="site-row-edit">
                <Grid2
                  container
                  size={{ xs: 12, sm: 6 }}
                  className="edit-panel"
                >
                  {Object.keys(controls).map((key, index) => {
                    return (
                      <Grid2 size={{ xs: 12 }} key={key + index}>
                        {controls[key].type === "text" && (
                          <Inputer
                            id={key}
                            setValue={setValue.bind(this)}
                            value={controls[key].value}
                            label={controls[key].label}
                            placeholder={controls[key].placeholder}
                            type={controls[key].type}
                            multiLine={controls[key].multiLine}
                          />
                        )}
                      </Grid2>
                    );
                  })}
                  <Grid2 size={{ xs: 12 }}>
                    <MButton
                      label={`Update ${
                        selected ? `(${selected.language})` : ""
                      }`}
                      onClick={onSubmit}
                      disabled={!editMode}
                      className="w-100"
                    />
                  </Grid2>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }} className="list-panel">
                  {row.languages.map((item) => {
                    return (
                      <div className="row-item">
                        <div className="row-language">
                          <p>{item.language}</p>
                        </div>
                        <div className="row-data">
                          <div className="row-action">
                            <div
                              className="btn-manager btn-edit"
                              onClick={() => handleRow(item)}
                            >
                              <Icons.Pencil />
                            </div>
                          </div>
                          <MInfoShow
                            label={"Title"}
                            data={item.title}
                            checkEmpty
                          />
                          <MInfoShow
                            label={"Text"}
                            data={item.body}
                            checkEmpty
                          />
                        </div>
                      </div>
                    );
                  })}
                </Grid2>
              </Grid2>
            )}
          </DialogContent>
          <DialogActions>
            <MButton label={"Close"} color="secondary" onClick={handleClose} />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
